import React, { useEffect } from 'react'
import AppLayout from 'components/layout/layout'
import InfoHeader from './InfoHeader'
import { Tabs } from 'antd'
import Details from './Tabs/Details'
import { useParams } from 'react-router-dom'
import { useGetLeagueById } from 'api/league/LeagueCreation/leagueCreation'
import Spinner from 'components/Spinner'
import { leagueEventStore } from 'state/league/leagueEvent'
import { manageTeamStore } from 'state/league/manageTeam'
import ManageteamModal from './Modals/ManageteamModal'
import AddTeamModal from './Modals/AddTeamModal'
import AddDiscountModal from './Modals/AddDiscountModal'
import CreateLeagueTeamModal from './Modals/CreateLeagueTeamModal'
import Schedule from './Tabs/Schedule'
import Updates from './Tabs/Updates'
import AttendanceTab from './Tabs/Attendance'
import StaffTab from './Tabs/Staff'
import AnalyticsTab from './Tabs/Analytics'
import SettingsTab from './Tabs/Settings'
import NotesTab from './Tabs/Notes'
import StandingsTab from './Tabs/Standings'

const { TabPane } = Tabs

const League: React.FC = () => {
  const { id }: { id: string } = useParams()
  const { leagueData, setLeagueData, activeTab, setActiveTab } = leagueEventStore(store => ({
    leagueData: store.leagueData,
    setLeagueData: store.setLeagueData,
    activeTab: store.activeTab,
    setActiveTab: store.setActiveTab,
  }))
  const { manageTeamModal, addTeamModal, addDiscountModal, createLeagueTeamModal } =
    manageTeamStore(state => ({
      manageTeamModal: state.manageTeamModal,
      addTeamModal: state.addTeamModal,
      addDiscountModal: state.addDiscountModal,
      createLeagueTeamModal: state.createLeagueTeamModal,
    }))

  const {
    data,
    isLoading: isLeagueLoading,
    isFetching: isLeagueDataFetching,
    isError: leagueFetchingError,
    refetch: refetchLeague,
  } = useGetLeagueById(id)

  useEffect(() => {
    refetchLeague()
  }, [id])

  useEffect(() => {
    setLeagueData(data)
  }, [isLeagueLoading, isLeagueDataFetching])

  if (leagueFetchingError) {
    return (
      <div className="flex justify-center items-center">
        <h1>Something went wrong</h1>
      </div>
    )
  }

  return (
    <>
      {isLeagueLoading || isLeagueDataFetching ? (
        <AppLayout>
          <div className="container-event py-40px flex justify-center items-center">
            <Spinner />
          </div>
        </AppLayout>
      ) : leagueData ? (
        <AppLayout>
          <div className="container-event">
            <div className="page-content evetns-page-content">
              <InfoHeader />
            </div>
            <div className="mt-30px">
              <Tabs
                className="bg-white profile-tabs"
                activeKey={activeTab}
                onChange={setActiveTab}
              >
                <TabPane tab="Details" key="1">
                  <Details />
                </TabPane>
                <TabPane tab="Schedule" key="2">
                  <Schedule />
                </TabPane>
                <TabPane tab="Updates" key="3">
                  <Updates />
                </TabPane>
                <TabPane tab="Analytics" key="4">
                  <AnalyticsTab />
                </TabPane>
                <TabPane tab="Standings" key="5">
                  <StandingsTab />
                </TabPane>
                <TabPane tab="Attendance" key="6">
                  <AttendanceTab />
                </TabPane>
                <TabPane tab="Staff" key="7">
                  <StaffTab />
                </TabPane>
                <TabPane tab="Notes" key="8">
                  <NotesTab />
                </TabPane>
                <TabPane tab="Settings" key="9">
                  <SettingsTab />
                </TabPane>
              </Tabs>
            </div>
          </div>
        </AppLayout>
      ) : (
        <div>Error on frontend side</div>
      )}

      {manageTeamModal && <ManageteamModal />}
      {addTeamModal && <AddTeamModal />}
      {addDiscountModal && <AddDiscountModal />}
      {createLeagueTeamModal && <CreateLeagueTeamModal />}
    </>
  )
}

export default League
